import { render, staticRenderFns } from "./ChannelsEmail.vue?vue&type=template&id=280c315a"
import script from "./ChannelsEmail.vue?vue&type=script&lang=js"
export * from "./ChannelsEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports